module.exports = __webpack_public_path__ + "media/src/images/icons/computer/primary-d15b1d440d0e3105105baaf4817c8043.svg";